export const parseInterval = (v:string, dmin:number, dmax:number) => {
	if(!v || typeof(v) !== "string"){ return [dmin, dmax]; }
	const s = v.split(",");
	let min = dmin;
	let max = dmax;
	if(s.length > 1){ max = Number(s[1]); }
	min = Number(s[0]);
	return [ min, max ];
};